module.exports = __webpack_public_path__ + "img/normal-big.04444087.svg";